import * as z from "zod"

export const TriagedEmailModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  message_id: z.string(),
  source: z.string(),
  outcome: z.string(),
  reason: z.string().nullish(),
  from_email: z.string(),
  subject: z.string(),
  received_at: z.date().nullish(),
  request_id: z.number().int().nullish(),
  draft_id: z.number().int().nullish(),
  matched_awb: z.string().nullish(),
  matched_quote_id: z.number().int().nullish(),
})
